import { Badge } from "@/components/ui/badge";
import { type BadgeVariant } from "@/components/ui/badge/badge.variants";
import { statusToVariant } from "@/components/ui/badge/statusToVariant";
import { cn } from "@/utils/cn";

interface Props {
  label: string;
  /** Variant or status string (e.g. "pending", "approved"); mapped to canonical via statusToVariant. */
  variant?: BadgeVariant | string;
  icon?: React.ReactNode;
  className?: string;
  /** @deprecated dot shown by default; pass `icon` to override */
  showIcon?: boolean;
}

const CANONICAL: ReadonlySet<BadgeVariant> = new Set([
  "neutral", "primary", "info", "success", "warning", "danger",
]);

const resolve = (v?: string): BadgeVariant => {
  if (!v) return "neutral";
  return CANONICAL.has(v as BadgeVariant)
    ? (v as BadgeVariant)
    : statusToVariant(v);
};

const Chip = ({ label, variant, icon, className }: Props) => (
  <Badge variant={resolve(variant)} dot={!icon} className={cn(className)}>
    {icon}
    {label}
  </Badge>
);

export default Chip;
